import { call, put, select } from 'redux-saga/effects';
import { pageContext, get } from 'ctm-util-functions';
import {
    getJourneyPayload,
    getLeadPayload,
    getMarketingRequestPayload,
    getProductPayload
} from './state_selectors';

import {
    logPayloadError,
    processErrorActions,
    processRequestAndActionsSaga,
    processRedirect,
    processSagaWithRetries
} from './utils';
import {getHasSavedResults} from "ctm-selectors/selectors/results";
import Immutable, { is } from "immutable";
import {quoteFormSelector} from "ctm-selectors";

/**
 * Process the Post and Get Payload action. i.e POST_PAYLOAD, GET_PAYLOAD, etc.
 * Find the payload for the request and catches any error while getting it.
 * Calls to the "processSagaWithRetries" generator to process the main Request and its actions in a loop using the request payload.
 * Process the redirects set on the schema when the action succeed.
 * @param {Object} action - The action that describes the request.
 */
export const processPayloadAction = function* (action) {
    const { apiSchema } = action;

    if (!apiSchema) {
        return;
    }

    // if user has saved prefill results, don't call for new results
    const hasSavedResult = getHasSavedResults();
    if (apiSchema.url === 'journey/result' && hasSavedResult) {
        const { store } = pageContext.getProps();
        const vertical = pageContext.getVertical();
        const form = JSON.parse(JSON.stringify(quoteFormSelector(store.getState())));

        const carActions = [{
            key: 'helpers.filters.requestedExcess',
            value: form?.coverDetail?.requestedExcess
        }];

        const homeContentsActions = [{
            key: 'helpers.filters.homeExcess',
            value: form?.excessDetails?.homeExcess
        }, {
            key: 'helpers.filters.contentsExcess',
            value: form?.excessDetails?.contentsExcess
        }];

        const isHomeContentsVertical = vertical === 'home-contents-insurance';
        let actions = [
            {
                key: 'isDisplayingResults',
                value: true
            }
        ];

        actions = isHomeContentsVertical ? [...actions, ...homeContentsActions] : [...actions, ...carActions];

        const resultsConfigAction = {
            type: 'SET_RESULTS_CONFIG_VALUES',
            actions
        };
        yield put(resultsConfigAction);
        return;
    }

    let requestPayload = null;

    // Clear the current state error before getting the payload or sending the request.
    yield put({ type: 'CLEAR_CURRENT_ERROR' });

    // Set the request Payload before fetching any request. This prevents to change the payload while fetching the request.
    if (apiSchema.requestPayload) {
        const verticalPayloadSelectors = get(pageContext.getProps().verticalSelectors, 'payloadSelectors', {});
        try {
            // Available Payloads.
            const PAYLOADS = {
                journey: getJourneyPayload,
                product: getProductPayload,
                lead: getLeadPayload,
                marketing: getMarketingRequestPayload,
                ...verticalPayloadSelectors
            };
            if (!PAYLOADS[apiSchema.requestPayload]) {
                throw Error(`Request Payload passed in does not exist: ${apiSchema.requestPayload}`);
            }
            // Get the payload for the action request.
            requestPayload = yield select(PAYLOADS[apiSchema.requestPayload], action);
        } catch (error) {
            // Log the payload error and show the error modal.
            yield call(logPayloadError, error, action, Date.now());
            // Process the actions on error.
            yield call(processErrorActions, error, action);
            yield call(processRedirect, action, 'redirectOnError');
            return;
        }
    } else if (action.requestPayload) {
        requestPayload = action.requestPayload;
    }

    // Process and retry (if failed) the request set on the requestAction property using the payload and its actions.
    yield call(processSagaWithRetries, processRequestAndActionsSaga, action, requestPayload);

    // Redirect user to the page specified in the schema.
    yield call(processRedirect, action, 'redirectResponse');
};
